module.exports = __webpack_public_path__ + "img/tarj2-12.212a2566.svg";